import React, { useContext, useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
import SignupButton from './miniComponents/SignupButton'
import 'C:/apps/ideafy/src/components/styles/MainPage.css'

const SecondSlide = ()=> {
    return (
        <div className = 'secondSlide'> 
            {/* <div className = 'containerTwo'> */}
            <h1>How It Works</h1>
            <div id = 'circles'>
                <div className = 'firstCircle'> 
                    <div className = 'circle'>
                        <h3>1</h3>
                    </div>
                    <div className = 'blockUnderCircle'>
                        {/* <h3>Tell Us About Your Interests and Choose the Role*</h3> */}
                        <h3>Tell us about your interests and choose the role*</h3>
                    </div>
                </div> 
                <div className = 'secondCircle' id ='centralCircle'> 
                    <div className = 'circle'>
                            <h3>2</h3>
                    </div>
                    <div className = 'blockUnderCircle'>
                        <h3>We find you a perfect match</h3>
                    </div>
                </div> 
                <div className = 'thirdCircle'> 
                    <div className = 'circle'>
                            <h3>3</h3>
                    </div>
                    <div className = 'blockUnderCircle'>
                            <h3>You connect with that person via a videochat</h3>
                    </div>
                </div> 
            </div>
            {/* </div> */}
        </div>
    )
}

export default SecondSlide 